import { formatDate } from '@/modules/_helpers/formatDate'
import config from '@/config'
import moment from 'moment'

const toArray = (prop) => {
  if (Array.isArray(prop)) {
    return prop
  } else {
    return []
  }
}

export default class EmailModel {
  constructor(data = {}) {
    this.id = data.id || undefined
    this.subject = data.subject || ''
    this.body = data.body || ''
    this.from = toArray(data.from)
    this.recipient = toArray(data.to)
    this.bcc = toArray(data.bcc)
    this.cc = toArray(data.cc)
    this.date = data.date || ''
    this.convertedDate = moment(data.date).toISOString()
    this.createdAt = data.createdAt || ''
    this.updatedAt = data.updatedAt || ''
    this.emailType = data.emailType || ''
    this.isAttachmentIncluded = data.isAttachmentIncluded || false
    this.customerData = data.customerData || {}
  }

  get dateSubstring() {
    return this.convertedDate ? formatDate(this.convertedDate) : ''
  }

  get dayMonth() {
    return this.convertedDate ? moment(this.convertedDate).format('DD.MM') : ''
  }

  get dayMonthYear() {
    return this.convertedDate ? formatDate(this.convertedDate, config.dateFormat.api, config.dateFormat.client) : ''
  }

  get timeSubstring() {
    return this.convertedDate ? moment(this.convertedDate).format('HH:mm') : ''
  }

  get dayMonthYearTime() {
    return this.convertedDate ? `${this.dayMonthYear} ${this.timeSubstring}` : ''
  }

  get isFromToday() {
    if (this.convertedDate) {
      const currentDate = moment().startOf('day')
      const emailDate = moment(this.convertedDate, [config.dateFormat.api, config.dateFormat.client])
      const dayDiff = emailDate.diff(currentDate, 'days')
      return dayDiff === 0
    }
  }
}
